/* eslint-disable no-restricted-syntax -- Not translatable strings */
import { t } from "@/i18n-js/instance";

export const FONT_FAMILY_OPTIONS = [
  {
    label: "System UI",
    value: "system-ui",
    group: "web-font",
  },
  {
    label: "Inter",
    value: "InterVariable",
    group: "web-font",
  },
  {
    label: "Arial",
    value: "Arial, sans-serif",
    group: "web-font",
  },
  {
    label: "Helvetica",
    value: "Helvetica, sans-serif",
    group: "web-font",
  },
  {
    label: "Verdana",
    value: "Verdana, sans-serif",
    group: "web-font",
  },
  {
    label: "Tahoma",
    value: "Tahoma, sans-serif",
    group: "web-font",
  },
  {
    label: "Trebuchet MS",
    value: "'Trebuchet MS', sans-serif",
    group: "web-font",
  },
  {
    label: "Times New Roman",
    value: "'Times New Roman', serif",
    group: "web-font",
  },
  {
    label: "Times",
    value: "Times, serif",
    group: "web-font",
  },
  {
    label: "Georgia",
    value: "Georgia, serif",
    group: "web-font",
  },
  {
    label: "Courier New",
    value: "'Courier New', monospace",
    group: "web-font",
  },
  {
    label: "Courier",
    value: "Courier, monospace",
    group: "web-font",
  },
  {
    label: "Consolas",
    value: "Consolas, monospace",
    group: "web-font",
  },
  {
    label: "Sans-serif",
    value: "sans-serif",
    group: "web-font",
  },
  {
    label: "Serif",
    value: "serif",
    group: "web-font",
  },
  {
    label: "Monospace",
    value: "monospace",
    group: "web-font",
  },
];

export const FONT_WEIGHT_OPTIONS = [
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.normal"),
    value: "400",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.medium"),
    value: "500",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.semibold"),
    value: "600",
  },
  {
    label: t("builder_ui.prop_type.styles.font_weight_types.bold"),
    value: "700",
  },
];

export const DEFAULT_UNITS = ["px", "rem", "em"];

export type Typography =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p1"
  | "p2"
  | "p3";

export type ActionSidebarViewType =
  | "h1TextStyles"
  | "h2TextStyles"
  | "h3TextStyles"
  | "h4TextStyles"
  | "h5TextStyles"
  | "h6TextStyles"
  | "p1TextStyles"
  | "p2TextStyles"
  | "p3TextStyles";

export const ACTION_SIDEBAR_VIEW_MAP: Record<
  ActionSidebarViewType,
  Typography
> = {
  h1TextStyles: "h1",
  h2TextStyles: "h2",
  h3TextStyles: "h3",
  h4TextStyles: "h4",
  h5TextStyles: "h5",
  h6TextStyles: "h6",
  p1TextStyles: "p1",
  p2TextStyles: "p2",
  p3TextStyles: "p3",
};
